import { SharePermissionState } from "@/types/programs";

export const SHARE_LABELS: Record<SharePermissionState, string> = {
  ["VIEW"]: "Can View",
  ["SHARE"]: "Can Share",
  ["EDIT"]: "Can Edit",
  ["REMOVE"]: "Remove",
};
